/*! cursor.js | v3.1.0 | license Copyright (C) 2019 - 2025 Taichi Matsutaka */
/*
 *
 * @name    : cursor.js
 * @content : cursor
 * @creation: 2019.02.20
 * @update  : 2025.12.29
 * @version : 3.1.0
 *
 */
(function(global) {[]
	global.cursor = function(options){
		///////////////////////////////////////////////////////////////
		// defaults options
		///////////////////////////////////////////////////////////////
		const _this = this;

		const defaults = {
			cursorClass    : ['js-cursor'],
			firstClass     : ['js-cursor-dot'],
			firstSpeed     : 0.2,
			firstInnerHTML : '',
			secondClass    : null,
			secondSpeed    : 0.1,
			secondInnerHTML: '',
			addStyle       : false,
			zindexBase     : 2147483648, // 最大値 + 1
			position       : 1,
			hovers :[
				[ '.smallElement' , 'is-small' ],
				[ '.mediumElement' , 'is-medium' ],
				[ '.largeElement' , 'is-large' ],
			],
		}


		///////////////////////////////////////////////////////////////
		// options
		///////////////////////////////////////////////////////////////
		for( let option in options){
			defaults[option] = options[option];
		}
		this.options = defaults;


		///////////////////////////////////////////////////////////////
		// base
		///////////////////////////////////////////////////////////////
		this.starts = [];
		this.stops = [];
		this.base();


	};
	cursor.prototype = {
		base: function(){
			const _this   = this;
			const options = this.options;



			///////////////////////////////////////////////////////////////
			// variable
			///////////////////////////////////////////////////////////////
			let mouse_clientX = 0;
			let mouse_clientY = 0;
			let first_x  = 0;
			let first_y  = 0;
			let second_x = 0;
			let second_y = 0;
			let flg = true;

			/* ---------- starts ---------- */
			_this.starts.push( function(){
				/* スタートするたびに flgを初期化 */
				flg = true;
			});



			///////////////////////////////////////////////////////////////
			// settings
			///////////////////////////////////////////////////////////////
			let setStyle = '';
			if( options['addStyle'] ==  true ){
				setStyle = function( element ){
					element.style.position      = 'fixed';
					element.style.top           = 0;
					element.style.left          = 0;
					element.style.zIndex        = options['zindexBase']--;
					element.style.pointerEvents = 'none';
				}
			} else{
				setStyle = function( element ){
				}
			}


			/* ---------- base ---------- */
			let cursorTarget = document.createElement('div');
			if( options['cursorClass'] != null ){
				for ( let i = 0; i < options['cursorClass'].length; i++ ) {
					cursorTarget.classList.add( options['cursorClass'][i] );
				}
			}

			/* ---------- first ---------- */
			let firstTarget    = document.createElement('div');
			if( options['firstClass'] != null ){
				for ( let i = 0; i < options['firstClass'].length; i++ ) {
					firstTarget.classList.add( options['firstClass'][i] );
				}
			}
			firstTarget.innerHTML = options['firstInnerHTML'];
			setStyle( firstTarget );
			cursorTarget.appendChild( firstTarget );

			/* ---------- second ---------- */
			let secondTarget = '';
			if( options['secondClass'] != null ){
				secondTarget = document.createElement('div');
				for ( let i = 0; i < options['secondClass'].length; i++ ) {
					secondTarget.classList.add( options['secondClass'][i] );
				}
				secondTarget.innerHTML = options['secondInnerHTML'];
				setStyle( secondTarget );
				cursorTarget.appendChild( secondTarget );
			}


			/* ---------- dom ---------- */
			if( options['position'] == 0 ){
				document.body.appendChild( cursorTarget );
			} else if( options['position'] == 1 ){
				document.body.insertBefore(cursorTarget, document.body.firstChild);
			} else{
				document.querySelector( options['position'] ).appendChild( cursorTarget );
			}




			///////////////////////////////////////////////////////////////
			// animation
			///////////////////////////////////////////////////////////////
			let requestId = '';

			/* ---------- stopAnimation ---------- */
			const stopAnimation = function(x,y){
				if(
					mouse_clientX == Math.round( x * 100) / 100 &&
					mouse_clientY == Math.round( y * 100) / 100 &&
					flg == false
				){
					window.cancelAnimationFrame( requestId );
					setTimeout(function(){
						flg = true;
					},20);
				}
			}

			let stopAnimationFrame;

			if( options['secondClass'] == null ){
				stopAnimationFrame = function(){
					stopAnimation( first_x , first_y );
				}
			} else{
				stopAnimationFrame = function(){
					stopAnimation( second_x , second_y );
				}
			}


			/* ---------- animation ---------- */
			const firstAnimation = function(){
				// console.log( first_x );
				first_x += ( mouse_clientX - first_x ) * options['firstSpeed'];
				first_y += ( mouse_clientY - first_y ) * options['firstSpeed'];
				firstTarget.style.transform = 'translate3d('+ first_x +'px,'+ first_y +'px,0)';

				stopAnimationFrame();
			};

			const secondAnimation = function(){
				second_x += ( mouse_clientX - second_x ) * options['secondSpeed'];
				second_y += ( mouse_clientY - second_y ) * options['secondSpeed'];
				secondTarget.style.transform = 'translate3d('+ second_x +'px,'+ second_y +'px,0)';

				stopAnimationFrame();
			};


			/* ---------- animationLoop ---------- */
			let animationLoop;

			if( options['secondClass'] == null ){
				animationLoop = function(){
					requestId = window.requestAnimationFrame( animationLoop );
					firstAnimation();
				}
			} else{
				animationLoop = function(){
					requestId = window.requestAnimationFrame( animationLoop );
					firstAnimation();
					secondAnimation();
				}
			}

			/* ---------- stops ---------- */
			_this.stops.push( function(){
				window.cancelAnimationFrame( requestId );
			});




			///////////////////////////////////////////////////////////////
			// mousemove
			///////////////////////////////////////////////////////////////
			const getMouseClient = function(){
				mouse_clientX = event.clientX;
				mouse_clientY = event.clientY;
				if( flg == true ){
					animationLoop();
					flg = false;
				}
			}

			/* ---------- starts ---------- */
			_this.starts.push( function(){
				window.addEventListener('mousemove',getMouseClient );
				window.addEventListener('pointermove',getMouseClient );
			});
			/* ---------- stops ---------- */
			_this.stops.push( function(){
				window.removeEventListener('mousemove',getMouseClient );
				window.removeEventListener('pointermove',getMouseClient );
			});




			///////////////////////////////////////////////////////////////
			// addStart
			///////////////////////////////////////////////////////////////
			function addStart(){
				cursorTarget.classList.add('is-start');
				window.removeEventListener('mousemove',addStart );
			}

			/* ---------- starts ---------- */
			_this.starts.push( function(){
				window.addEventListener('mousemove',addStart );
			});
			/* ---------- stops ---------- */
			_this.stops.push( function(){
				window.removeEventListener('mousemove',addStart );
			});




			///////////////////////////////////////////////////////////////
			// hover
			///////////////////////////////////////////////////////////////
			function addHoverClass( event ){
				cursorTarget.classList.add( event.target.addClass );
			}
			function removeHoverClass( event ){
				cursorTarget.classList.remove( event.target.addClass );
			}

			/* ---------- starts ---------- */
			_this.starts.push( function(){
				for ( let i = 0; i < options['hovers'].length; i++ ) {
					let num = i;
					let hoverTarget = document.querySelectorAll( options['hovers'][num][0] );
					for ( let i = 0; i < hoverTarget.length; i++ ) {
						hoverTarget[i].addClass = options['hovers'][num][1];

						hoverTarget[i].addEventListener('mouseenter', addHoverClass, false);
						hoverTarget[i].addEventListener('mouseleave', removeHoverClass, false);
					}
				}
			});

			/* ---------- stops ---------- */
			_this.stops.push( function(){
				for ( let i = 0; i < options['hovers'].length; i++ ) {
					let num = i;
					let hoverTarget = document.querySelectorAll( options['hovers'][num][0] );
					for ( let i = 0; i < hoverTarget.length; i++ ) {
						hoverTarget[i].removeEventListener('mouseenter', addHoverClass);
						hoverTarget[i].removeEventListener('mouseleave', removeHoverClass);
					}
				}
			});




			///////////////////////////////////////////////////////////////
			// start
			///////////////////////////////////////////////////////////////
			_this.start();




		},
		start: function(){
			/* starts に追加されたremove関数をforで一つずつ実行する。 */
			const starts = this.starts;

			if( !starts ){
				return;
			}

			for ( let i = 0; i < starts.length; i++ ) {
				starts[i]();
			}
		},
		stop: function(){
			/* stops に追加されたremove関数をforで一つずつ実行する。 */
			const stops = this.stops;

			if( !stops ){
				return;
			}

			for ( let i = 0; i < stops.length; i++ ) {
				stops[i]();
			}
		},
	};

})(this);
